
import { Injectable } from '@angular/core';
import { UserSessionService } from '@core/services/session/user-session.service';
import { Observable, map } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class AuthRolesService {
	constructor(private userSession: UserSessionService) {}

	get type(): Observable<string | null> {
		return this.userSession.user$.pipe(map((user) => user?.type ?? null));
	}

	isAdmin(): Observable<boolean> {
		return this.type.pipe(map((userType) => userType === 'adm'));
	}

	isUser(): Observable<boolean> {
		return this.type.pipe(map((userType) => userType === 'client'));
	}

	isDev(): Observable<boolean> {
		return this.type.pipe(map((userType) => userType === 'dev'));
	}

	getCurrentUserType(): string | null {
		return this.userSession.userType();
	}

	isAdminSync(): boolean {
		return this.getCurrentUserType() === 'adm';
	}

	isUserSync(): boolean {
		return this.getCurrentUserType() === 'client';
	}

	isDevSync(): boolean {
		return this.getCurrentUserType() === 'dev';
	}
}
